import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import {
  HeaderContainer,
  LogoHeader,
  HeaderInforContainer,
  NavItem
} from "./styles";

// images
import logo from "../../assets/images/logos/uniodonto@153x90.png";

export default function Header() {
  return (
    <HeaderContainer>
      <Container>
        <Row>
          <Col xs={6} md={9}>
            <LogoHeader src={logo} alt="Uniodonto Maceió" />
          </Col>
          <Col xs={6} md={3}>
            <HeaderInforContainer>
              <Link to="/">
                <NavItem>Inicio</NavItem>
              </Link>
              <Link to="/plans">
                <NavItem>Planos</NavItem>
              </Link>
            </HeaderInforContainer>
          </Col>
        </Row>
      </Container>
    </HeaderContainer>
  );
}
